import {invalidateQueries, q} from "../../state";
import {CreateThirdPartyTier, ThirdPartyTierId, ThirdPartyTierMin} from "../../Types";
import {CURRENT_REGION} from "../../utils/region";
import jsonApi from "../jsonApi";

export async function list(): Promise<ThirdPartyTierMin[]> {
  return await jsonApi.get<ThirdPartyTierMin[]>(`/region/${CURRENT_REGION}/api/tprm/third_party_tiers`);
}

export async function create(tier: CreateThirdPartyTier) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/tprm/third_party_tiers`, tier);
  await invalidateQueries([q.tprm.thirdPartyTiers.filter()]);
  return res;
}

export async function updateTitle(tierId: ThirdPartyTierId, title: string) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/tprm/third_party_tiers/${tierId}/title`, title);
  await invalidateQueries([q.tprm.thirdPartyTiers.filter()]);
  return res;
}

export async function updateColor(tierId: ThirdPartyTierId, color: string) {
  const res = await jsonApi.post<"ok">(`/region/${CURRENT_REGION}/api/tprm/third_party_tiers/${tierId}/color`, color);
  await invalidateQueries([q.tprm.thirdPartyTiers.filter()]);
  return res;
}

export async function reorder(tierId: ThirdPartyTierId, ordinal: number) {
  const res = await jsonApi.post<"ok">(
    `/region/${CURRENT_REGION}/api/tprm/third_party_tiers/${tierId}/ordinal`,
    ordinal,
  );
  await invalidateQueries([q.tprm.thirdPartyTiers.filter()]);
  return res;
}

export async function delete_(tierId: ThirdPartyTierId) {
  const res = await jsonApi.delete_<"ok">(`/region/${CURRENT_REGION}/api/tprm/third_party_tiers/${tierId}`);
  await invalidateQueries([q.tprm.thirdPartyTiers.filter()]);
  return res;
}
